import React from 'react';
import { Link } from 'react-router-dom';

import Image from 'react-bootstrap/Image';

import useUser from 'hooks/useUser';
import { MainRoutes } from 'helpers/routes';

import AnnouncementBanner from 'components/announcements/AnnouncementBanner';

import NavMenu from './NavMenu';

const AppHeader = () => {
  const { appUser } = useUser();

  const greeting = appUser?.nickname
    ? `Hello, ${appUser.nickname}`
    : appUser?.name && `Hello, ${appUser.name}`;

  const rightColumn = (
    <div className="d-flex flex-column align-items-end">
      <Link to={`${MainRoutes.TRAINING}?cat=DataDictionary`}>
        <Image src="/assets/data_dictionary.png" height="59" />
      </Link>
      {greeting && <span>{greeting}</span>}
    </div>
  );

  return (
    <div>
      <div className="d-flex d-md-none justify-content-between p-2">
        <a rel="noopener noreferrer" href={MainRoutes.HOME}>
          <Image src="/assets/aba_burn_care_logo.svg" height="86" />
        </a>
        {rightColumn}
      </div>

      <div className="d-none d-md-flex align-items-center p-2">
        <div className="flex-grow-1">
          <a rel="noopener noreferrer" href={MainRoutes.HOME}>
            <Image src="/assets/aba_burn_care_logo.svg" height="86" />
          </a>
        </div>
        <AnnouncementBanner className="announcement-banner--header" />
        <div className="flex-grow-1 d-flex justify-content-end">
          {rightColumn}
        </div>
      </div>

      <NavMenu />
    </div>
  );
};

export default AppHeader;
